import { WA_LINKS } from "@/constants/site";

export default function WhatsAppFab() {
  return (
    <a
      href={WA_LINKS.info}
      target="_blank"
      rel="noopener"
      aria-label="Escribir a CLEM por WhatsApp"
      className="group fixed right-4 z-[60] flex h-[60px] w-[60px] items-center justify-center rounded-full bg-wa text-white shadow-[0_6px_20px_rgba(0,0,0,0.28)] transition-transform hover:scale-105 md:right-6 md:h-16 md:w-16"
      style={{ bottom: "calc(16px + env(safe-area-inset-bottom))" }}
    >
      <span aria-hidden="true" className="wa-pulse-ring" />
      <i className="ri-whatsapp-fill text-3xl md:text-4xl" aria-hidden="true" />

      <span className="pointer-events-none absolute right-[72px] top-1/2 hidden -translate-y-1/2 whitespace-nowrap rounded-md bg-ink px-3 py-2 text-xs font-medium text-cream opacity-0 transition-opacity duration-200 group-hover:opacity-100 md:block">
        ¿Reservas o dudas? Escríbenos
      </span>
    </a>
  );
}